import { css } from '@flipster/styled-system/css';
import { circle, grid } from '@flipster/styled-system/patterns';

import { ContentCard } from '@web/graphql/types.generated';

interface Props {
  cards?: (ContentCard | null)[];
}

export const ContentCards = ({ cards }: Props) => {
  if (!cards || cards.length === 0) return null;

  return (
    <div
      className={grid({
        columns: { base: 1, tablet: cards.length },
        gridAutoRows: '1fr',
        gap: { base: 16, tablet: 24 },
        my: { base: 24, tablet: 48 },
      })}
    >
      {cards.filter(Boolean).map((card, index) => {
        if (!card) return null;
        return (
          <div
            key={card.sys.id}
            className={css({
              p: { base: 20, tablet: 32 },
              bg: 'background.default.level-1',
              rounded: 16,
            })}
          >
            {!card.icon && (
              <div
                className={circle({
                  w: { base: 40, tablet: 60 },
                  h: { base: 40, tablet: 60 },
                  textStyle: 'Display/L',
                  color: 'content.default.level-5',
                  textAlign: 'center',
                  bg: 'background.accent.primary',
                })}
              >
                {index + 1}
              </div>
            )}
            {card.icon?.url && (
              <img
                src={card.icon.url}
                alt={card.icon.title || 'card icon'}
                className={css({
                  w: { base: 50, tablet: 70 },
                  h: { base: 50, tablet: 70 },
                  mb: 0,
                })}
              />
            )}
            <h4
              className={css({ textStyle: 'Title/L', color: 'content.default.level-4', my: { base: 16, tablet: 24 } })}
            >
              {card.title}
            </h4>
            <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-3' })}>{card.description}</p>
          </div>
        );
      })}
    </div>
  );
};
